import { useQuery } from "@tanstack/react-query";
import { fetchCompanyMembers } from "@/lib/companyMembers";
import { useCurrentCompany } from "@/hooks/useCurrentCompany";

export function useCompanyMembers() {
  const { id: companyId } = useCurrentCompany();
  return useQuery({
    queryKey: ["company_members", companyId],
    enabled: !!companyId,
    staleTime: 5 * 60_000,
    queryFn: fetchCompanyMembers,
  });
}
